import { useField } from 'formik'
import React from 'react'
import { Form } from 'semantic-ui-react'
import FWOLabel from './FWOLabel'

interface Props {
  placeholder: string
  name: string
  type?: string
  rows: number
  label?: string
  tooltip?: string
  htmlTooltip?: string
  defaultHtmlTooltipIconText?: string
  required: boolean
  showreadonly?: boolean
}

const FWOTextAreaInput = (props: Props) => {
  const [field, meta] = useField(props.name)
  const hasError =
    meta.touched && (field.value === null || field.value === '') && !!meta.error
  return (
    <Form.Field error={hasError}>
      <FWOLabel
        label={props.label}
        name={props.name}
        tooltip={props.tooltip}
        required={props.required}
        htmlTooltip={props.htmlTooltip}
        defaultHtmlTooltipIconText={props.defaultHtmlTooltipIconText}
      />
      {hasError ? <span className="validation-error">{meta.error}</span> : null}
      <textarea
        {...field}
        {...{
          name: props.name,
          type: props.type,
          label: props.label,
          rows: props.rows,
          placeholder: props.placeholder,
        }}
        aria-label={hasError ? props.label + meta.error : props.label}
        title={`${props.tooltip == null ? '' : props.tooltip}`}
        {...{ readOnly: props.showreadonly == true }}
      />
    </Form.Field>
  )
}

export default FWOTextAreaInput
